import { Flex, Icon } from '@chakra-ui/react'
import { Frown, Meh, Smile } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

interface OverallSentimentStatusProps {
  overallSentimentScore: number
  personType: string
}

const sentimentText = (
  sentiment: number,
  t: (key: string) => string,
): string => {
  if (sentiment >= 1) return t('callDetails.sentiment.positive')
  if (sentiment <= -1) return t('callDetails.sentiment.negative')
  return t('callDetails.sentiment.neutral')
}

const sentimentIcon = (sentiment: number) => {
  return sentiment >= 1 ? Smile : sentiment <= -1 ? Frown : Meh
}

export const OverallSentimentStatus = ({
  overallSentimentScore,
  personType,
}: OverallSentimentStatusProps) => {
  const { t } = useTranslation()
  return (
    <Flex gap="0.5rem" alignItems="center">
      <Icon height="1.65rem" width="1.65rem" borderRadius="1.5rem">
        {React.createElement(sentimentIcon(overallSentimentScore), {
          width: '1em',
          height: '1em',
        })}
      </Icon>
      <Flex
        flexDirection="column"
        gap="0"
        height="100%"
        justifyContent="center"
      >
        <Flex color="fg.default" {...textStyles[textStyleKeys.Body2]}>
          {personType}
        </Flex>
        <Flex color="fg.muted" {...textStyles[textStyleKeys.Body3]}>
          {sentimentText(overallSentimentScore, t)}
        </Flex>
      </Flex>
    </Flex>
  )
}
